import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  Button,
  useTheme,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getPriorityColor } from '../utils/priorityColors';

const PriorityPanel = ({ id, importanceControl, dueDateControl, priority }) => {
  const [showInfo, setShowInfo] = useState(false);
  const theme = useTheme();
  const numericPriority = Number.parseFloat(priority);
  const hasPriority = Number.isFinite(numericPriority);
  const priorityColor = hasPriority
    ? getPriorityColor(numericPriority, theme)
    : theme.palette.text.secondary;

  return (
    <>
      <Box
        id={id}
        component="fieldset"
        sx={{
          border: '1px solid',
          borderColor: 'primary.main',
          borderRadius: 2,
          px: 2,
          pb: 2,
          pt: 1,
          m: 0,
          width: '100%',
          minWidth: 0,
          boxSizing: 'border-box',
        }}
      >
        <Box
          component="legend"
          sx={{ color: 'primary.main', px: 1, fontWeight: 700 }}
        >
          Priority
        </Box>
        <Stack spacing={2}>
          {importanceControl}
          {dueDateControl}
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="body2" color="primary.main">
                Priority score
              </Typography>
              <Typography
                aria-label="Calculated priority"
                role="status"
                sx={{
                  color: priorityColor,
                  fontSize: '1.6rem',
                  fontWeight: 800,
                  lineHeight: 1.2,
                  textShadow: `0 0 10px ${priorityColor}`,
                }}
              >
                {priority}
              </Typography>
            </Box>
            <IconButton
              aria-label="How priority is calculated"
              color="primary"
              onClick={() => setShowInfo(true)}
            >
              <InfoOutlinedIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Box>

      <Dialog open={showInfo} onClose={() => setShowInfo(false)}>
        <DialogTitle>How priority is calculated</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The priority score is based on the Eisenhower Matrix. More important
            tasks and tasks closer to their due date receive a higher score.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowInfo(false)} autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PriorityPanel;
